export default {
  apparel: {
    description:
      "Hemp clothing and other cannabis-themed apparel for men and women.",
    title: "Apparel",
  },
  balms: {
    title: "Balms",
  },
  beauty: {
    title: "Beauty",
  },
  beverages: {
    description:
      "From sodas to waters to tonics, find THC and CBD infused beverages that are sure to please a variety of palates while quenching your thirst.",
    faq_title: "marijuana drinks",
    faqs: [
      {
        answer:
          'Yes, you can drink weed. THC drinks, also known as “cannabis drinks,” “weed drinks,” and “weed beverages,” are a popular way to consume cannabis. THC drinks come in a variety of options including <a href="/news/lifestyle/how-to-make-cannabis-infused-tea">tea</a>, elixirs, sparkling waters, juices, and sodas. Consumers prefer THC drinks because they are discrete and are easy to dose.',
        question: "Can you drink weed?",
      },
      {
        answer:
          "The effects of drinking weed are very similar to the effects you experience when consuming an edible, such as a brownie or gummy. The effects of drinking weed will come on slowly and may be long-lasting depending on the amount consumed as well as the dosage.",
        question: "What are the effects of drinking weed?",
      },
      {
        answer:
          'You can buy cannabis drinks online using Leafly.com. On Leafly, you can browse a selection of cannabis drinks near you and place a pickup order to be processed at your local neighborhood dispensary. You can also use Leafly.com to find <a href="/dispensaries">dispensaries near you</a> that offer special deals or discounts on THC drinks.',
        question: "Where do I buy cannabis drinks? Online or near me? ",
      },
    ],
    featured_product: "weed and CBD drinks",
    title: "THC and CBD Drinks",
  },
  "books-games": {
    description: "Explore these popular cannabis-themed books and games.",
    title: "Books & games",
  },
  brownies: {
    description:
      "Shop one of the most iconic edibles, weed brownies. Find your favorite edible brownies in various THC strengths and flavors for your next session.",
    title: "Edible brownies",
  },
  candy: {
    faq_title: "weed candy",
    faqs: [
      {
        answer:
          'The effects of weed candy edible are long-lasting but slow to kick in. The exact amount of time you will feel effects from candy edible depends on factors like THC content, <a href="https://www.leafly.com/learn/consume/edibles/edible-dosing" class="underline">dosage</a>, and type of strain used for the candy. Because of this, the best way to approach candies, mints, lozenges, or gum is to start low and take it slow until you know how each kind of edible affects your body.',
        question: "What are the effects of weed candies?",
      },
      {
        answer:
          "Edible candies infused with THC or CBD usually run on the cheaper end of the price spectrum, especially if you’re looking for single servings. In general, the price of candy edibles ranges from $5-30. The total price depends on factors such as local taxes, servings, THC strength, and quality of ingredients used.",
        question: "How much are THC candies?",
      },
      {
        answer:
          "Yes, THC and CBD candy edibles can expire. On average, edible candies will last up to six months. After that, THC begins to degrade and the edible will lose potency. When you buy edible mints, gums, lozenges, it’s always important to read the packaging to make sure you are storing it appropriately so it will retain the expected potency and flavor. This type of information is usually available on the packaging of your gummies or candy.",
        question: "Do edible marijuana candies expire?",
      },
      {
        answer:
          'You can buy edible candy online for <a href="/dispensaries" class="underline">in-store pick up</a> or for <a href="/delivery" class="underline">delivery</a>. Leafly is an app that allows you to place pickup orders online for edible candies at a dispensary near you. Alternatively, you can use the Leafly app to find the closest dispensary near you to see their edible offerings before you visit in-person. Either way, ordering online is the easiest and quickest way to buy edible candy, gums, and mints.',
        question: "How do I buy edible candy? Online or in-person?",
      },
    ],
    title: "Weed candy",
  },
  cannabis: {
    description: "Browse the best of the best cannabis in its original form.",
    title: "Cannabis",
  },
  capsules: {
    title: "Capsules",
  },
  cartridges: {
    description:
      "These preloaded cannabis oil dab cartridges are<br />made for vaping on the go. Keep your favorite THC vape<br />carts close, no matter where you are.",
    image: "/products/category-heroes/product-heroes-v4-1920x500-carts-1x.jpg",
    title: "THC vape pen cartridges",
  },
  chocolates: {
    faq_title: "marijuana chocolate products",
    faqs: [
      {
        answer:
          "No, chocolate edibles are not considered to be significantly stronger than other THC-infused edibles. In general, the potency of chocolate edibles depends on a variety of factors including the total amount of THC content, the dose you take, and your unique biological system.",
        question: "Are chocolate edibles stronger?",
      },
      {
        answer:
          "The price of weed chocolate bars range from $10-20. You can also buy weed chocolate bars in single servings, which usually cost $3-6. The actual price of weed chocolate bars can vary depending on the total THC content, quality of ingredients used, and taxes applied (if applicable).",
        question: "How much are weed chocolate bars?",
      },
      {
        answer:
          "Weed chocolate bars last up to six months. Like other THC-infused edibles, after six months have passed, the weed chocolate bar will begin to lose its potency and flavor. If you still have questions, ask your budtender about the longevity of any weed chocolate products you buy.",
        question: "How long do weed chocolate bars last? ",
      },
      {
        answer:
          'You can buy cannabis chocolate online at Leafly.com for pickup at a <a href="/dispensaries">dispensary</a> in your neighborhood. Using Leafly.com, you can easily find dispensaries offering discounts and deals on cannabis chocolate.',
        question: "Where can I buy cannabis chocolate? Online or near me?",
      },
    ],
    title: "Chocolates",
  },
  clones: {
    description:
      "Looking to grow your own cannabis? Start with a high quality marijuana clone from dispensaries near you to get started.",
    faq_title: "cannabis clones",
    faqs: [
      {
        answer:
          "Cannabis clones are trimmings from a cannabis plant that are propagated to create a 'clone' of the original plant. Using clones is considered to be easier than traditional <a href='/learn/growing' class='text-green'>growing</a> processes.",
        question: "What are cannabis clones?",
      },
      {
        answer:
          "Cannabis clones are legally considered to be the same as any ordinary cannabis plant. This means that if cannabis plants are <a href='/learn/legalization' class='text-green'>illegal in your state</a>, so are cannabis clones.",
        question: "Are cannabis clones legal?",
      },
      {
        answer:
          "Cloning cannabis plants is an incredibly easy process. Not only does propagation simplify the growing process, but it makes it incredibly consistent. Cannabis cloning is a good way to know exactly what kind of plant you will end up with.",
        question: "What are the benefits of growing a cannabis clone?",
      },
      {
        answer:
          "Because cannabis clones are exact copies of the original plant, they become especially susceptible to disease. This means that if one cannabis clone contracts a disease, it can quickly spread across any nearby clone.",
        question: "Are there any risks when growing cannabis clones?",
      },
      {
        answer:
          "You can shop cannabis clones online through Leafly. This page will display our full listing of marijuana clones for sale at a shop near you.",
        question: "Where can you buy a cannabis clone?",
      },
      {
        answer:
          "In states where growing personal cannabis plants are legal, adults must be over the age of 21 in order to purchase and cultivate a cannabis clone.",
        question: "How old must you be to purchase a cannabis clone?",
      },
    ],
    moreInfo:
      "Browse our selection of high-quality cannabis clones from a range of weed <a href='/strains/lists' class='text-green'>strains</a> to find a licensed dispensary or grower near you online or in these <a href='/learn/legalization' class='text-green'>states</a>. Growing cannabis using a clone, or weed cutting, is considered one of the easiest ways to grow a cannabis plant. For beginner growers, check out Leafly’s <a href='/learn/growing' class='text-green'>guide to growing marijuana</a> for some great tips and tricks on growing clones to help you maximize your first harvest.",
    moreInfoCategory: "cannabis clones",
    title: "Cannabis clones",
  },
  concentrates: {
    description:
      "Shop THC oil, wax, and shatter at Leafly. Browse our selection of solventless and solvent based cannabis concentrates for your all your dabbing needs.",
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-concentrates-1x.jpg",
    moreInfo:
      'Concentrates, also called oils or extracts, is an umbrella term for a beloved form of cannabis that offers an experience you can\'t get from flower alone. A concentrate, oil, or extract is any product made when cannabis flower is processed down into cannabis oil, removing all parts of the plant except essential oils and cannabinoids. You\'ll find these oils in many form factors. Something you already enjoy may in fact be a cannabis extract. Some examples include tinctures, capsules, vaporizers, hash, and a whole range of dabbable oils like THC wax, CBD wax, shatter, rosin, or isolates. Oil enthusiasts report enjoying a smokeless option — you vaporize or ingest oils, rather than smoke them. If you want to learn more about concentrates, <a class="underline" href="https://www.leafly.com/learn/consume/dabs">here\'s a good place to start.</a><br><br> A dab is a concentrated cannabis dose made by extracting <a class="underline" href="https://www.leafly.com/news/cannabis-101/what-is-cannabinoid">THC and other cannabinoids</a> using a solvent like butane or carbon dioxide, resulting in sticky oils. Depending on their consistency, these marijuana concentrates are also commonly referred to as wax, shatter, budder, and butane hash oil (BHO). Weed wax and other dabs are typically heated on a hot surface, like a dab nail, and then inhaled through a <a class="underline" href="https://www.leafly.com/learn/consume/dabs/how-to-dab-cannabis">dab rig</a>. Dabbing weed has been around for at least a decade, but newer, more advanced extraction methods and dab tools have led to a flood of cannabis concentrates that are boosting dabbing\'s popularity. Shop Leafly for the best dab rigs, cheap dab rigs, and a huge selection of dab accessories.',
    title: "Cannabis concentrates, THC oil, and wax",
  },
  cookies: {
    title: "Edible weed cookies",
  },
  dabbing: {
    description:
      "Take your consumption to the next level with dabbing. Find the best dabbing products and concentrates to experience cannabis in a purer form.",
    title: "Dabbing",
  },
  default: {
    description:
      "Buy all types of cannabis and CBD products, plus deals available in your area.",
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-all-products-1x.jpg",
  },
  "delta-8-carts": {
    title: "Delta-8 THC cartridges and vapes",
  },
  "delta-8-edibles": {
    description:
      "From baked goods to gummies, edibles made with Delta-8 THC are a popular choice thanks to their mild effects and wide availability.",
    title: "Delta-8 THC edibles",
  },
  "delta-8-other": {
    title: "Other products containing delta-8 THC",
  },
  "delta-8-thc": {
    description:
      "Delta-8 flower, edibles, carts, and distillates are surging in popularity right now thanks to their wide availability and desirable effects. Use Leafly to find out exactly where to buy Delta-8 THC near you.",
    faqs: [
      {
        answer:
          "Yes, in some states you can legally buy Delta-8 THC products online including flower, edibles, concentrates, and topicals.",
        question: "Can I legally order products containing Delta-8 online?",
      },
      {
        answer:
          "Currently, Delta-8 is federally legal under the 2018 farm bill. However, it remains illegal in some states because they have not adopted the language of that bill. The federal government is reviewing its laws on THC, and Delta-8 may or may not be made illegal in the future.",
        question: "Are products made with Delta-8 federally legal?",
      },
      {
        answer:
          "Yes, the USPS allows Delta-8 to be legally shipped. However, it’s important to check the producer website you’re buying from to ensure they ship to your state.",
        question: "Can Delta-8 products be shipped?",
      },
      {
        answer:
          "No, CBD and Delta-8 THC are not the same thing. Delta-8 and CBD have different production processes and produce different effects. For example, CBD produces no psychoactive effects and consumers typically use it for medicinal benefits. On the other hand, Delta-8 produces mild psychoactive effects and is usually enjoyed for recreational purposes.",
        question: "Are Delta-8 THC products the same as CBD?",
      },
      {
        answer:
          "Delta-8 is federally legal in states that have adopted the specific language outlined in the 2018 farm bill.",
        question: "Is Delta-8 legal in all states?",
      },
      {
        answer:
          "Yes, with passage of the 2018 Farm Bill you can purchase Delta-8 products legally.",
        question: "Can you buy Delta-8 THC products legally?",
      },
    ],
    image: "/products/category-heroes/product-heroes-v4-1920x500-delta8-1x.jpg",
    moreInfo:
      '<a href="/news/science-tech/what-is-delta8-thc">Delta-8 THC</a> has quickly become one of the most sought-after cannabis products on the market. While there is still much to learn about this cannabinoid, it hasn’t stopped consumers from dabbling and enjoying locally-sourced products made with the unique compound. In general, cannabis products made with Delta-8 are regarded as having <a href="/news/strains-products/i-tried-delta-8-thc-heres-what-it-feels-like">mild effects</a> and a lower potency when compared with traditional products containing THC.',
    moreInfoCategory: "products with Delta-8 THC",
    title: "Delta-8 THC",
  },
  "delta-8-topicals": {
    title: "Delta-8 THC topicals",
  },
  edibles: {
    description:
      "Weed and CBD edibles can be quite effective. Shop infused options like gummies, candy, and chocolates, there’s something for everyone to enjoy. Just remember: start low and go slow.",
    faq_title: "edibles",
    faqs: [
      {
        answer:
          "The right dose of weed edibles is different for everyone. Start with a small dose, especially if it's your first time or it's been a while since you've used cannabis. Each person's response to a dose of edible cannabis can vary significantly, more so than with other medications or herbs. The “standard dose” is considered 10 mg, but someone new to cannabis or with low tolerance should start with half of that. Trial-and-error is an integral part of finding the perfect dose for a great experience, just remember to start low and slow.",
        question: "What edible dose is right for me?",
        readMorePath: "/learn/consume/edibles/edible-dosing",
        readMoreText: "Cannabis Edibles Dosing Chart: Find the Right Dose",
      },
      {
        answer:
          "The amount of time it takes for the effects of edibles to kick in varies and also depends on your metabolism. People with faster metabolisms may feel effects after an hour; people with slower metabolisms may not feel the effects for two hours or more. An important factor is whether you consume the edible on an empty stomach or after you've eaten. An empty stomach will feel the effects much more quickly — a full stomach will keep it from hitting you as hard.",
        question: "How long does it take for weed edibles to kick in?",
        readMorePath:
          "/news/cannabis-101/5-tips-to-safely-dose-and-enjoy-cannabis-edibles",
        readMoreText: "5 Tips to Safely Dose and Enjoy Cannabis Edibles",
      },
      {
        answer:
          "If you become uncomfortably high, don't panic. A cannabis overdose isn't fatal, it's just uncomfortable and possibly disorienting. Find a safe, comfortable place to rest. Put on music that eases you. Closing your eyes can also help. Take long, slow, deep breaths, ideally of fresh air – open a window if possible. And hydrate!",
        question: "What should I do if I ate too much weed edibles?",
        readMorePath:
          "/news/cannabis-101/8-ways-to-counteract-a-too-intense-cannabis-high",
        readMoreText: "8 Ways to Counteract a Too-Intense Cannabis High",
      },
      {
        answer:
          "Marijuana products aren't yet FDA regulated, which can result in a lack of consistency in dosage from one product to another. This can make finding the right dose even more difficult. Look for products that are clearly labeled and read the label carefully to figure out the correct portion size for the dose that works best for you.",
        question: "What should I look for on a cannabis edible label?",
        readMorePath:
          "/news/cannabis-101/medibles-101-everything-youve-ever-wanted-to-know-about-edibles",
        readMoreText: "What to Know About Dosing, Potency, and Labeling",
      },
      {
        answer:
          "It may not surprise you that it's hard to pinpoint the exact length of the effect of a marijuana edible. The short answer: it varies. Generally, the effects of edibles can be felt up to about 5-6 hours. This varies widely based on your individual biology, the dose, and the type of edible consumed. The peak euphoric experience may only last 1-3 hours but may continue for much longer. Bottom line: start with a low dose and slowly work your way up to avoid uncomfortably long and uncomfortably potent effects.",
        question: "How long do weed edibles last?",
      },
      {
        answer:
          "If you don't feel any effects from a marijuana edible after an hour, try eating a snack like an organic apple to turn on the digestion and absorption in your gut. Some people new to cannabis may not feel anything the first few times they try edibles, so it's often best to try the same low dose three times with 8 to 24 hours between tries before you increase the dose.",
        question:
          "What to do if you don't feel the effects from a weed edible after an hour?",
      },
      {
        answer:
          "<a href='https://www.leafly.com/learn/cannabis-glossary/edibles'>Weed edibles</a> is a term that refers to any food item that contains CBD or THC. Weed edibles are fun because they come in a variety of forms including drinks, snacks, candy, desserts, and more. Cannabis consumers choose weed edibles because the effects are long lasting and don't require inhalation. Another reason weed edibles are so popular with consumers is because they are much more discreet than smoking, vaping, or dabbing.",
        question: "What are weed edibles?",
      },
      {
        answer:
          "Weed edibles look just like food. For example, a weed brownie will look just like a regular brownie your grandma would make. Without cannabis packaging—which is required in all legal states—it's nearly impossible to tell the difference between an edible and a non-edible simply by looking at it. Because of this, weed edibles are extremely discreet. ",
        question: "What do weed edibles look like?",
      },
      {
        answer:
          "The cost of weed edibles varies and is based on a number of factors including THC content, quality of ingredients used, geographic location, and local taxes. In general, weed edibles cost anywhere from $8.00 to $60.00 each. THC candies are typically on the lower end of the price spectrum, with single servings priced at around $10 or less. An edible brownie will run slightly higher, usually over $10. Bigger edibles products like batches of cannabutter sell for around $55 each.",
        question: "How much do weed edibles cost at a dispensary?",
      },
      {
        answer:
          'You can buy edibles online using Leafly.com. With Leafly, you can place a pickup order online for weed edibles available in your area including cannabutter, THC candy, and THC-infused drinks. You can also use Leafly.com to find deals on marijuana edibles at <a href="/dispensaries">dispensaries near you</a>.',
        question: "Where can I buy marijuana edibles? ",
      },
    ],
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-edibles-1x.jpg",
    moreInfo:
      "Edible forms of cannabis, including food products, lozenges, and capsules, can produce effective, long-lasting, and safe effects. Most weed edibles contain a significant amount of tetrahydrocannabinol (THC). THC-dominant edibles are consumed for recreational and medical purposes and can induce a wide range of effects including relaxation, euphoria, increased appetite, fatigue, and anxiety. Some edibles feature other cannabinoids predominantly—most commonly cannabidiol (CBD) with very little THC. To learn more, browse our library of great edibles to find the type that works best for you.",
    title: "Weed edibles",
  },
  flower: {
    description:
      "Cannabis flower, au naturale. Indica, sativa, or hybrid flower, you can trust Leafly to find the bud that’s right for you.",
    image: "/products/category-heroes/product-heroes-v4-1920x500-flower-1x.jpg",
    title: "Cannabis flower and buds",
  },
  grinders: {
    description:
      "Using a weed grinder doesn't just make life easier, it often yields a more enjoyable, consistent experience. Shop our range of cute, cool, and sleek grinders made just for you.",
    title: "Weed grinders",
  },
  growing: {
    description:
      "Dreaming of growing your own cannabis? Finding the right supplies—like grow lights and tents—can help you realize your dreams, no matter if it's indoor or outdoor or the size of your operation.",
    title: "Weed growing supplies",
  },
  "hemp-cbd": {
    description:
      "Hemp-derived CBD provides good feels without the buzz. From edibles to topicals, CBD may offer some help with issues like sleep, relaxation, mood, and pain.",
    faqs: [
      {
        answer:
          "Hemp-derived CBD is extracted from non-intoxicating industrial hemp varieties that produce less than 0.3% THC. Cannabis-derived CBD generally refers to varieties of cannabis that were selectively bred to contain higher levels of CBD along with a diverse spectrum of other cannabinoids and terpenes.",
        question:
          "What's the difference between hemp CBD and cannabis-derived CBD?",
        readMorePath:
          "/news/science-tech/is-cbd-from-cannabis-the-same-as-cbd-from-cannabis",
        readMoreText: "Is CBD From Cannabis the Same as CBD From Cannabis?",
      },
      {
        answer:
          "Although hemp-derived CBD products containing less than 0.3% THC are legal on the federal level, some state laws still prohibit hemp CBD. Marijuana-derived CBD products are illegal federally, but some state laws allow their use. Check your state's laws and those of anywhere you travel.",
        question: "Is CBD legal?",
        readMorePath: "/news/health/what-to-know-before-you-try-cbd",
        readMoreText: "What to Know Before You Try CBD",
      },
      {
        answer:
          "Both CBD and THC are cannabinoids found in cannabis. THC (tetrahydrocannabinol) is the chemical compound in cannabis known for producing a euphoric high feeling, while CBD (cannabidiol) is a non-intoxicating compound more commonly associated with clear-headed, functional effects.",
        question: "What's the difference between CBD and THC?",
        readMorePath: "/news/cbd/cbd-vs-thc",
        readMoreText: "CBD vs. THC: What's the Difference?",
      },
      {
        answer:
          "Hemp—also known as industrial hemp—is a tall, fast-growing cannabis plant that resembles bamboo. Hemp's stalks and seeds can be used to make a variety of products. Hemp has naturally low levels of THC (less than 0.3%), so using hemp-derived CBD products does not provide the high commonly associated with marijuana products.",
        question: "What is hemp?",
        readMorePath:
          "/news/cannabis-101/hemp-101-what-is-hemp-whats-it-used-for-and-why-is-it-illegal",
        readMoreText:
          "Hemp 101: What Is Hemp, What's It Used for, and Why Is It Illegal?",
      },
      {
        answer:
          "In short: no. Hemp—or industrial hemp—is a flowering cannabis plant. CBD is a non-intoxicating cannabinoid derived from the cannabis plant.",
        question: "Is hemp the same as CBD?",
        readMorePath:
          "/news/cannabis-101/industrial-hemp-derived-cbd-whats-there-to-know",
        readMoreText: "Industrial Hemp-Derived CBD: What's There to Know?",
      },
    ],
    hideCanada: true,
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-hempCBD-1x.jpg",
    moreInfo:
      "Hemp CBD is extracted from hemp—also called industrial hemp—which refers to the non-intoxicating varieties of cannabis. Hemp-derived CBD products contain less than 0.3% THC, so they do not produce the high typically associated with marijuana. Hemp-based CBD products are frequently used for several issues associated with wellness, including sleep, relaxation, mood, skin care, and focus.",
    title: "CBD products",
  },
  "hemp-edibles": {
    description:
      "Browse a wide variety of tasty hemp-derived CBD edibles, from capsules to<br />caramels to coffee and beyond.",
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-hempCBD-1x.jpg",
    title: "CBD Edibles",
  },
  "hemp-oil": {
    description:
      "Feel the chill and shop CBD oil from today's top brands. CBD oil can be applied topically or ingested to naturally help reduce anxiety, aid in sleep, and achieve overall wellness.",
    title: "Hemp CBD Oil",
  },
  "hemp-tinctures": {
    description:
      "Feel the chill and shop CBD tinctures from today's top brands. CBD tinctures are absorbed sublingually to naturally help reduce anxiety, aid in sleep, and achieve overall wellness.",
    title: "CBD tinctures",
  },
  "hemp-topicals": {
    description:
      "Feel the chill and shop CBD topicals from today's top brands. These lotions, creams, and balms contain hemp-derived CBD that's absorbed through the skin, with no intoxicating effects.",
    image: "/consumer-web/shop/topicals-hero.jpg",
    title: "CBD Topicals",
  },
  indica: {
    is_collection: true,
    title: "Indica products",
  },
  lotions: {
    title: "Lotions",
  },
  "lubricants-oils": {
    title: "Lubricants & Oils",
  },
  other: {
    description:
      "Some products might not fit squarely in one category or another, but there's nothing wrong with being unique. Explore a digital grab bag of assorted cannabis delights.",
    title: "Other",
  },
  pets: {
    description:
      "Shop CBD pet treats and tinctures formulated exclusively for cats and dogs.",
    faqs: [
      {
        answer:
          'One key factor in determining whether a CBD (cannabidiol) product is safe is to make sure that it has been transparently tested. Look for a certificate of analysis to ensure that the product contains what it states on the label. Because hemp-based CBD contains very low levels of THC, CBD treats will not give your pet an intoxicating high. The <a class="underline" href="/news/strains-products/vet-talks-cbd-oil-dogs">known side effects</a> of high-quality, certified CBD products in dogs are generally mild and non-harmful.',
        question: "Is CBD oil OK for my dog?",
        readMorePath: "/news/strains-products/vet-talks-cbd-oil-dogs",
        readMoreText: "A Vet Weighs in on CBD Oil for Dogs",
      },
      {
        answer:
          "Finding the right dosage of CBD in treats, capsules, and tinctures for your dog or cat will involve some exploration, but some important factors to consider are your pet's size, age, and the intended therapeutic effect. Consult with your vet or a holistic veterinarian who has experience recommending cannabis-derived products for pets, and always start with a low dose before gradually adjusting the dosage upward over time based on your pet's needs.",
        question: "How do I determine the right CBD dosage for my pet?",
        readMorePath:
          "/news/cannabis-101/medical-marijuana-for-pets-what-to-know",
        readMoreText:
          "5 Things to Know Before Using Medical Cannabis for Your Pets",
      },
      {
        answer:
          'Although there isn\'t a lot of solid, peer-reviewed research on the effects of CBD in pets, a <a class="underline" href="https://www.frontiersin.org/articles/10.3389/fvets.2018.00165/full">clinical study at Cornell University</a> examining the effects of hemp-based CBD on arthritic dogs found a significant decrease in pain and improved mobility in more than 80% of participants. While the Cornell study on CBD effects in dogs is focused on pain and mobility issues due to arthritis, many pet owners and vets have found hemp CBD to be effective for different uses.',
        question: "What do CBD treats do for pets?",
        readMorePath:
          "/news/health/what-science-says-about-giving-dogs-cats-cannabis-cbd",
        readMoreText:
          "The Science Behind Giving CBD & Cannabis to Cats and Dogs",
      },
    ],
    moreInfo:
      'Animals, like humans, have an <a href="/news/science-tech/what-is-the-endocannabinoid-system">endocannabinoid</a> system that is capable of interacting with the chemical compounds found in cannabinoids like CBD and THC. Older dogs and cats or pets with conditions like arthritis, seizures, anxiety, and inflammation, among others, may experience beneficial effects from a CBD treat, tincture, or capsule. Because they contain less than 0.3% THC, hemp-derived CBD products are not intoxicating and will not get your pet high.',
    title: "CBD for pets",
  },
  prerolls: {
    description:
      "Shop blunts, marijuana pre-rolls, and joints online at Leafly. Browse the best marijuana brands and read reviews of top cannabis products to help you choose.",
    faq_title: "cannabis pre-rolls",
    faqs: [
      {
        answer:
          "Cannabis pre-rolls and blunts have many benefits when compared to other forms of consuming cannabis. Cannabis pre-rolls are regarded by consumers as being extremely convenient because pre-rolls are portable, discrete, and require little work from the consumer aside from lighting the end with a lighter or match. Beyond that, pre-rolls and pre-roll blunts are a great way to sample different strains of cannabis, making it easier to decide which strains you'd like to buy more of later.",
        question: "What are the benefits of cannabis pre-rolls?",
      },
      {
        answer:
          "The price of pre-rolled joints ranges from $5-30. There are many factors that can impact the cost of pre-rolls, including cannabis taxes, quality of flower, and type of pre-roll. For example, infused pre-rolls tend to cost more than regular pre-rolls. In some states, you may also find pre-rolls sold in packs, which will be more expensive than buying single pre-rolls.",
        question: "How much do pre-rolled joints cost?",
      },
      {
        answer:
          "You can buy marijuana pre-rolls online using Leafly.com. On Leafly, you can place an online order for marijuana pre-rolls for pick up at your local marijuana dispensary. Alternatively, you can use Leafly.com to find dispensaries near you with marijuana pre-rolls on their menu. No matter how you approach it, you can order joints online.",
        question: "Where can I buy marijuana pre-rolls online or near me?",
      },
    ],
    featured_product: "Marijuana Pre-roll",
    image:
      "/products/category-heroes/product-heroes-v4-1920x500-prerolls-1x.jpg",
    title: "Pre-rolled joints and blunts",
  },
  relaxing: {
    description:
      "Elevate your well-deserved chill time with these premium cannabis products.",
    is_collection: true,
    title_i18n: "shop.relaxing_products",
  },
  "rolling-machines": {
    description:
      "Having a rolling machine makes rolling joints quick and easy every time. Shop our selection of joint rollers in a variety of sizes.",
    title: "Joint rollers",
  },
  sativa: {
    is_collection: true,
    title: "Sativa products",
  },
  seeds: {
    description:
      "Marijuana seeds for all types of growers and climates:<br />regular, feminized, and autoflower. Shop cannabis seeds<br />from the best seed banks online.",
    faq_title: "cannabis seeds",
    faqs: [
      {
        answer:
          "Cannabis seeds are the most common form of <a href='/learn/growing' class='text-green'>growing cannabis</a>. Starting with planting a seed in the soil, cannabis plants need tender care for them to grow into healthy adult plants.",
        question: "What are cannabis seeds?",
      },
      {
        answer:
          "Cannabis seeds are legally considered to be the same as any ordinary cannabis plant. This means that if cannabis plants are <a href='/learn/legalization' class='text-green'>illegal in your state</a>, so are cannabis seeds.",
        question: "Are cannabis seeds legal?",
      },
      {
        answer:
          "Growing cannabis with seeds will make your cannabis plant less susceptible to disease. The alternative (cloning cannabis plants) leaves them at a greater risk.",
        question: "What are the benefits of growing cannabis with seeds?",
      },
      {
        answer:
          "Growing cannabis from seeds is considered to be a far more difficult and laborious process compared to cloning.",
        question: "What are the downsides of growing cannabis with seeds?",
      },
      {
        answer:
          "You can shop cannabis seeds online through Leafly. This page will display our full listing of marijuana seeds for sale at a shop near you.",
        question: "Where can you buy cannabis seeds?",
      },
      {
        answer:
          "In states where growing personal cannabis plants are legal, adults must be over the age of 21 in order to purchase and cultivate cannabis seeds.",
        question: "How old must you be to purchase cannabis seeds?",
      },
    ],
    image: "/products/category-heroes/product-heroes-v4-1920x500-seeds-2x.jpg",
    moreInfo:
      "<p>Browse a wide selection of feminized and auto-flowering cannabis seeds from the best seed banks and companies near you. The culture of growing weed from seeds continuously evolves and you can buy premium seeds online or in-store in these <a href='/learn/legalization' class='text-green'>states</a>. Shop your favorite weed <a href='/strains/lists' class='text-green'>strain</a> seeds from licensed growers and dispensaries.</p> <p>For beginner growers, check out Leafly’s <a href='/learn/growing' class='text-green'>guide to growing marijuana</a> for some great tips and tricks on growing seeds to help you maximize your first harvest.</p>",
    moreInfoCategory: "cannabis seeds",
    title: "Marijuana Seeds",
  },
  services: {
    description:
      "Browse Leafly's database of cannabis-friendly business services.",
    title: "Services",
  },
  sleeping: {
    description:
      "Elevate your well-deserved chill time with these premium cannabis products.",
    is_collection: true,
    title_i18n: "shop.sleeping_products",
  },
  smoking: {
    description: "Browse the best of the best cannabis smoking accessories.",
    title: "Smoking",
  },
  solvent: {
    title: "Solvent",
  },
  solventless: {
    title: "Solventless",
  },
  storage: {
    description: "Explore cannabis storage containers and solutions.",
    title: "Storage",
  },
  topicals: {
    description:
      "People use topical cannabis to soothe everything from small aches and pains to bruises, and inflammation. Shop our range of cannabis lotions, balms and more.",
    image: "/consumer-web/shop/topicals-hero.jpg",
    title: "Cannabis topicals",
  },
  tourism: {
    description:
      "Marijuana tourism is a budding industry. Start planning your next trip here.",
    title: "Tourism",
  },
  "transdermal-patches": {
    title: "Transdermal Patches",
  },
  "vape-pens": {
    description:
      "Explore crowd-pleasing discreet and ultra-portable weed pens for THC oil by today's best brands.",
    faqs: [
      {
        answer:
          'Weed vape pens come in a variety of shapes, styles, and sizes. The best vape pen for you depends entirely on your preferred cannabis starting material. In most dispensaries, you will find three different types of vape pens, including:<ul><li>Oil vape pens (refillable or prefilled)</li><li>Dry herb vape pens</li><li>Dab pens</li></ul>If you decide to buy an THC oil pen, know that there are two primary options: prefilled and refillable. Pre-filled oil pens are single use and can be bought at a dispensary. Refillable oil pens are advantageous because they can be used over again and are regarded as better for the environment.<br /><br /> For vaping flower, you will want a dry herb vaporizer. If you only smoke wax, you can buy a dab pen.<br /><br />You can also buy a weed vape online at Leafly.com for in-store pick up at your <a class="underline" href="https://www.leafly.com/dispensaries">local dispensary</a> or order for <a class="underline" href="https://www.leafly.com/delivery">delivery</a>.',
        question: "What are the different types of THC vape pens?",
      },
    ],
    title: "Weed vape pens",
  },
  vaping: {
    description:
      "From desktop units to vape pens, there’s a weed vaporizer for everyone. Leafly can help you find your new setup.",
    faqs: [
      {
        answer:
          "Vaping is the heating of cannabis flower or concentrate without burning. The heat releases the active ingredients into a vapor that is then released into the air in a fine mist created by a vaporizer device. While research on cannabis vaporizing is limited, studies have shown that vaping does produce fewer carcinogenic compounds than smoking because the cannabis is not combusted.",
        question: "What is vaping, and is it safe?",
        readMorePath: "/news/health/vaping-vs-smoking-marijuana-safety",
        readMoreText:
          "Is Vaping Safe? The Differences Between Vaping vs. Smoking Cannabis",
      },
      {
        answer:
          "Vaporizers — also known as vape pens — are devices used to heat cannabis for inhalation. Vaping devices heat dry cannabis flower or oil concentrate to a temperature below combustion, usually in the range of 180 to 200°C (356 to 392°F). The heat releases active compounds from the cannabis and turns them into a vapor that can be inhaled.",
        question: "What are vaporizers?",
        readMorePath:
          "/news/strains-products/what-are-pre-filled-cannabis-oil-vape-cartridges",
        readMoreText:
          "Everything You Need to Know About Pre-Filled Oil Vape Cartridges",
      },
      {
        answer:
          "Marijuana vaporizers come in portable or table-top varieties, and different types of vaporizers can be used for marijuana flower or oil concentrate. Choosing which one is right for you involves considering what kind of product you'd like to consume and whether or not you are likely to need to take your vape on the go.",
        question: "What are the types of weed vaporizers?",
        readMorePath:
          "/news/strains-products/which-type-of-vaporizer-best-suits-you",
        readMoreText: "Which Type of Vaporizer Best Suits You?",
      },
      {
        answer:
          "While choosing a vaping device is ultimately a matter of personal preference, there are several factors that can help you compare different products. One difference to consider is whether the product has proprietary cartridge technology or if it instead features a standard 510-threaded battery, and how many choices for each are available in your area. Other options to think about are the type of cannabis oil and whether you prefer a disposable or reusable cartridge.",
        question: "How do I buy a marijuana vaporizer?",
        readMorePath:
          "/news/strains-products/heres-how-to-buy-and-review-vape-carts",
        readMoreText: "Here's How to Buy and Review Vape Carts",
      },
    ],
    image: "/products/category-heroes/product-heroes-v4-1920x500-vapes-1x.jpg",
    moreInfo:
      "Vaporizing, or vaping, cannabis is a smokeless process that involves heating dry flower or concentrate without burning it. Vape pens are popular for their ease of use, portability, and because they offer an opportunity for more consistent dosing than other methods of inhaling marijuana. Browse our library of the best vaping devices to find the size and features that work best for you.",
    title: "Weed vaporizers and vapes",
  },
} as {
  [key: string]: {
    image?: string;
    description?: string;
    featured_product?: string;
    title?: string;
    moreInfo?: string;
    moreInfoCategory?: string;
    faqs?: Array<{
      answer: string;
      question: string;
      readMorePath?: string;
      readMoreText?: string;
    }>;
    faq_title?: string;
  };
};
